import type { HistoryPhoto } from "./history"

const CACHE_LIFETIME = 5 * 60 * 1000

// Retain only list metadata and signed URLs in this tab, never downloaded photos.
let cached: { userId: number; photos: HistoryPhoto[]; expiresAt: number } | undefined
let expiryTimer: ReturnType<typeof setTimeout> | undefined

export function clearImageSearchHistoryCache(userId?: number) {
  if (userId !== undefined && cached?.userId !== userId) return
  clearTimeout(expiryTimer)
  expiryTimer = undefined
  cached = undefined
}

export function getCachedHistoryPhotos(userId: number | undefined) {
  if (!cached || cached.userId !== userId) return undefined
  if (cached.expiresAt <= Date.now()) {
    clearImageSearchHistoryCache()
    return undefined
  }
  return cached.photos
}

export function cacheHistoryPhotos(userId: number | undefined, photos: HistoryPhoto[]) {
  if (userId === undefined) return
  clearImageSearchHistoryCache()
  cached = { userId, photos, expiresAt: Date.now() + CACHE_LIFETIME }
  expiryTimer = setTimeout(clearImageSearchHistoryCache, CACHE_LIFETIME)
}

export function forgetHistoryThumbnail(userId: number | undefined, photoId: string) {
  const photos = getCachedHistoryPhotos(userId)
  if (photos) {
    cacheHistoryPhotos(
      userId,
      photos.map((photo) => (photo.id === photoId ? { ...photo, thumbnail: null } : photo))
    )
  }
}

export function forgetHistoryPhoto(userId: number | undefined, photoId: string) {
  const photos = getCachedHistoryPhotos(userId)
  if (photos)
    cacheHistoryPhotos(
      userId,
      photos.filter((photo) => photo.id !== photoId)
    )
}
